/* eslint-disable @typescript-eslint/naming-convention */
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  DispatchGridView,
  DispatchGridViews,
  ErrorHandlingDispatch,
  GridType,
  GridViewDialogData,
  GridViewSelect,
  GridViewSortBy,
  GridViewsState,
} from '../types';
import {
  HeaderCellConfiguration,
  WcgTableFilters,
} from '@wcg/frontend-framework';

/**
 * @Fetch
 * */
const getGridViewsAction = () => props<{ gridType: GridType }>();

/**
 * @Save
 * */
const onSaveGridView = () => props<DispatchGridView>();

/**
 * @updates
 * */

const onBulkUpdateGridViews = () => props<DispatchGridViews>();

const onUpdateGridView = () => props<DispatchGridView>();

/**
 * @Delete
 * */
const onDeleteGridViews = () => props<DispatchGridViews>();

/**
 * @Success
 * */
const onGetGridViewsSuccess = () =>
  props<{ grid: GridViewsState; grid_type: GridType }>();

const onSaveGridViewSuccess = () => props<DispatchGridView>();

const onBulkUpdateGridViewSuccess = () => props<DispatchGridViews>();

const onUpdateGridViewSuccess = () => props<DispatchGridView>();

const onDeleteGridViewsSuccess = () => props<DispatchGridViews>();

/**
 * @Failures
 * */
const onSaveGridViewFailure = () => props<ErrorHandlingDispatch>();

const onBulkUpdateGridViewFailure = () => props<ErrorHandlingDispatch>();

const onUpdateGridViewFailure = () => props<ErrorHandlingDispatch>();

const onDeleteGridViewsFailure = () => props<ErrorHandlingDispatch>();

export const GRID_VIEW_ACTIONS = createActionGroup({
  events: {
    deleteGridView: onDeleteGridViews(),
    deleteGridViewFailure: onDeleteGridViewsFailure(),
    deleteGridViewSuccess: onDeleteGridViewsSuccess(),
    getGridViewsAction: getGridViewsAction(),
    onBulkUpdateGridViewFailure: onBulkUpdateGridViewFailure(),
    onBulkUpdateGridViewSuccess: onBulkUpdateGridViewSuccess(),
    onBulkUpdateGridViews: onBulkUpdateGridViews(),
    onGetGridViewsSuccess: onGetGridViewsSuccess(),
    onSaveGridView: onSaveGridView(),
    onSaveGridViewFailure: onSaveGridViewFailure(),
    onSaveGridViewSuccess: onSaveGridViewSuccess(),
    onUpdateGridView: onUpdateGridView(),
    onUpdateGridViewFailure: onUpdateGridViewFailure(),
    onUpdateGridViewSuccess: onUpdateGridViewSuccess(),
  },
  source: '[Grid View]',
});

/**
 * @DIALOG ACTIONS
 * */
const openGridViewDialog = () => props<{ data: GridViewDialogData }>();

export const GRID_VIEW_DIALOG_ACTIONS = createActionGroup({
  events: {
    closeGridViewDialog: emptyProps(),
    openGridViewDialog: openGridViewDialog(),
  },
  source: '[Grid View] Dialog',
});

/**
 * @STORE_DATA_ACROSS COMPONENTS
 * */
const setCustomViewSelection = () =>
  props<{
    selectedView: GridViewSelect;
  }>();

const setCustomFilters = () =>
  props<{
    filters?: WcgTableFilters;
    sortBy: GridViewSortBy;
  }>();

export const GRID_VIEW_DATA_ACTIONS = createActionGroup({
  events: {
    setCustomFilters: setCustomFilters(),
    setCustomViewSelection: setCustomViewSelection(),
  },
  source: '[Grid View] Data',
});

/**
 * @DEFAULT TABLE HEADERS
 * */
const saveDefaultTableHeaders = () =>
  props<{
    headers: HeaderCellConfiguration[];
  }>();

export const GRID_VIEW_TABLE_ACTIONS = createActionGroup({
  events: {
    resetToDefaultUpOnSave: emptyProps(),
    saveDefaultTableHeaders: saveDefaultTableHeaders(),
  },
  source: '[Grid View] Table',
});
